import { put, call, takeLatest, debounce } from "redux-saga/effects";
import { showErrorToast } from "util/toastUtils";
import {
    // Pre-order Summary
    preOrderEventOverviewSuccess,
    preOrderEventOverviewFailure,
    preOrderByOrderDateSuccess,
    preOrderByOrderDateFailure,
    preOrderByPickupSlotSuccess,
    preOrderByPickupSlotFailure,
    preOrdersByChannelsSuccess,
    preOrdersByChannelsFailure,

    // Pre-order Details
    preOrderDetailsSuccess,
    preOrderDetailsFailure,
    eventNameFilterValuesSuccess,
    eventNameFilterValuesFailure,
    eventSlotsFilterSuccess,
    eventSlotsFilterFailure
} from "./eventReportsActions";
import {
    // Pre-order Summary
    PRE_ORDER_EVENT_OVERVIEW_REQUEST,
    PRE_ORDER_BY_ORDER_DATE_REQUEST,
    PRE_ORDER_BY_PICKUP_SLOT_REQUEST,
    PRE_ORDERS_BY_CHANNELS_REQUEST,

    // Pre-order Details
    PRE_ORDER_DETAILS_REQUEST,
    EVENT_NAME_FILTER_VALUES_REQUEST,
    EVENT_SLOTS_FILTER_REQUEST
} from "./eventReportsConstants";
import {
    // Pre-order Summary
    getPreOrderEventOverview,
    getPreOrderByOrderDate,
    getPreOrderByPickupSlot,
    getPreOrdersByChannels,

    // Pre-order Details
    getPreOrderDetails,
    getEventNameFilterValues,
    getEventTimeSlotsFilter
} from "./eventReportsApi";
import { decryptJson } from "util/react-ec-utils";

// Pre-order Event Overview Saga
export function* preOrderEventOverviewSaga(action) {
    try {
        const response = yield call(getPreOrderEventOverview, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(preOrderEventOverviewSuccess(decryptedData));
        } else {
            yield put(preOrderEventOverviewFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(preOrderEventOverviewFailure(error));
    }
}

// Pre-order By Order Date Saga
export function* preOrderByOrderDateSaga(action) {
    try {
        const response = yield call(getPreOrderByOrderDate, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(preOrderByOrderDateSuccess(decryptedData));
        } else {
            yield put(preOrderByOrderDateFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(preOrderByOrderDateFailure(error));
    }
}

// Pre-order By Pickup Slot Saga
export function* preOrderByPickupSlotSaga(action) {
    try {
        const response = yield call(getPreOrderByPickupSlot, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(preOrderByPickupSlotSuccess(decryptedData));
        } else {
            yield put(preOrderByPickupSlotFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(preOrderByPickupSlotFailure(error));
    }
}

// Pre-orders By Channels Saga
export function* preOrdersByChannelsSaga(action) {
    try {
        const response = yield call(getPreOrdersByChannels, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(preOrdersByChannelsSuccess(decryptedData));
        } else {
            yield put(preOrdersByChannelsFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(preOrdersByChannelsFailure(error));
    }
}

// Pre-order Details Saga
export function* preOrderDetailsSaga(action) {
    try {
        const response = yield call(getPreOrderDetails, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(preOrderDetailsSuccess(decryptedData));
        } else {
            yield put(preOrderDetailsFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(preOrderDetailsFailure(error));
    }
}

// Event Name Filter Values Saga
export function* eventNameFilterValuesSaga(action) {
    try {
        const response = yield call(getEventNameFilterValues, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(eventNameFilterValuesSuccess(decryptedData));
        } else {
            yield put(eventNameFilterValuesFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(eventNameFilterValuesFailure(error));
    }
}

// Event Time Slots :
export function* eventTimeSlotsFilterSaga(action) {
    try {
        const response = yield call(getEventTimeSlotsFilter, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(eventSlotsFilterSuccess(decryptedData));
        } else {
            yield put(eventSlotsFilterFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(eventSlotsFilterFailure(error));
    }
}


export default function* watchNewReportRequest() {
    // Pre-order Summary
    yield takeLatest(PRE_ORDER_EVENT_OVERVIEW_REQUEST, preOrderEventOverviewSaga);
    yield takeLatest(PRE_ORDER_BY_ORDER_DATE_REQUEST, preOrderByOrderDateSaga);
    yield takeLatest(PRE_ORDER_BY_PICKUP_SLOT_REQUEST, preOrderByPickupSlotSaga);
    yield takeLatest(PRE_ORDERS_BY_CHANNELS_REQUEST, preOrdersByChannelsSaga);

    // Pre-order Details
    yield debounce(1000, PRE_ORDER_DETAILS_REQUEST, preOrderDetailsSaga);

    // Event Name Filter Values :
    yield takeLatest(EVENT_NAME_FILTER_VALUES_REQUEST, eventNameFilterValuesSaga)

    // Event Time Slots :
    yield takeLatest(EVENT_SLOTS_FILTER_REQUEST, eventTimeSlotsFilterSaga)
}